import React from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Helmet } from 'react-helmet';
import { useAuth } from 'src/contexts/AuthContext';
import toastMessage from 'src/utils/toast';
import { getErrorMessage } from 'src/lib/utils';
import { Button } from 'src/components/ui/button';
import { Input } from 'src/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from 'src/components/ui/card';
import FormField from 'src/components/admin/FormField';
import Logo from 'src/components/admin/Logo';

const Login = () => {
  const history = useHistory();
  const { signIn, isAuth, initializing } = useAuth();

  React.useEffect(() => {
    if (!initializing && isAuth) history.replace('/app/dashboard');
  }, [isAuth, initializing, history]);

  return (
    <>
      <Helmet>
        <title>Connexion | IZYA Admin</title>
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <Card className="w-full max-w-md">
          <CardHeader className="space-y-4">
            <Logo size="lg" className="mx-auto rounded-xl" />
            <div>
              <CardTitle className="text-2xl">Connexion</CardTitle>
              <CardDescription>
                Accédez au tableau de bord d&apos;administration IZYA.
              </CardDescription>
            </div>
          </CardHeader>
          <CardContent>
            <Formik
              initialValues={{
                email: process.env.REACT_APP_ADMIN_EMAIL || 'admin@izya.local',
                password: process.env.REACT_APP_ADMIN_PASSWORD || 'Password123!'
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .email('Adresse e-mail invalide')
                  .max(255)
                  .required('E-mail obligatoire'),
                password: Yup.string().max(255).required('Mot de passe obligatoire')
              })}
              onSubmit={async ({ email, password }) => {
                try {
                  await signIn(email, password);
                  history.push('/app/dashboard');
                } catch (error) {
                  toastMessage(getErrorMessage(error), 'error');
                }
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <FormField
                    id="email"
                    label="Adresse e-mail"
                    required
                    error={touched.email && errors.email}
                  >
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </FormField>
                  <FormField
                    id="password"
                    label="Mot de passe"
                    required
                    error={touched.password && errors.password}
                  >
                    <Input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      value={values.password}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </FormField>
                  <Button type="submit" className="w-full" loading={isSubmitting}>
                    Se connecter
                  </Button>
                </form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default Login;
